import { Box } from "@mui/material";
import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { CMForm } from "../../components/common/Form/CMForm";
import { PageHeader } from '../../components/common/PageHeader/PageHeader';
import { editUsers, getByUsersId, getRole, getstatus } from "./UsersServices";
import { emailRegex, floatingRegex, phoneRegex } from "../../components/common/Helpers/Validations";
import * as yup from "yup";

export const formFields: any = [
    {
        label: "First Name",
        type: 'text',
        name: 'f_name',
        placeholder: 'Enter First Name'
    },
    {
        label: "Last Name",
        type: 'text',
        name: 'l_name',
        placeholder: 'Enter Last Name'
    },
    {
        label: "Email",
        type: 'text',
        name: 'email',
        placeholder: 'Enter Email'
    },
    {
        label: "Mobile Number",
        type: 'text',
        name: 'mobile_number',
        placeholder: 'Enter Mobile Number'
    },

    {
        label: "Address",
        type: 'text',
        name: 'address',
        placeholder: 'Enter Address'
    },
    {
        label: "Status",
        type: 'dropdown',
        name: 'status',
        placeholder: 'Enter Status',
        options: getstatus
    },

    {
        label: "Role",
        type: 'dropdown',
        name: 'role_id',
        placeholder: 'Enter Role',
        options: getRole
    },
]

export const validationSchema = yup.object({
    f_name: yup.string().ensure().required("First Name is required!").min(3, 'To short!'),
    l_name: yup.string().ensure().required("Last Name is required!").min(3, 'To short!'),
    email: yup.string().ensure().required("Email is required!").min(3, 'To short!').matches(emailRegex,{message:'Enter Valid Email'}),
    password: yup.string().ensure().required(" Password is required!").min(3, 'To short!'),
    mobile_number: yup.string().ensure().required(" Mobile Number is required!").min(10, 'Invalid Mobile Number').max(10, 'Invalid Mobile Number').matches(phoneRegex,{message:'Enter Valid Mobile Number',}),
    address: yup.string().ensure().required("Address is required!").min(3, 'To short!'),
    status: yup.object().required("Status is required!"),
    role_id: yup.object().required("Role is required!"),
});

export const UsersEdit = () => {

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>

                    <Row>
                        <Col lg={12}>
                            <Box component="div" sx={{ mt: 2 }}>
                                <PageHeader header="Edit AdminUser" />
                                <CMForm
                                    validationSchema={validationSchema}
                                    formFields={formFields}
                                    addService={editUsers}
                                    listPageKey='USERS_LIST'
                                    type="edit"
                                    detailService={getByUsersId}
                                />
                            </Box>
                        </Col>
                    </Row>

                </Container>
            </div>
        </React.Fragment>
    )
}
